import { Skeleton, useMediaQuery } from "@mui/material";
import { TitleContainer } from "./styles";

export const CompaniesSkeleton = () => {
  const isTablet = useMediaQuery("(max-width:768px)");
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <>
      <TitleContainer
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          gap: "14px",
          alignItems: "center",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={isMobile ? "320px" : "500px"}
          height={isMobile ? "24px" : "32px"}
          style={{ borderRadius: "20px" }}
        />

        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "1240px",
            alignItems: "center",
          }}
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={isMobile ? "48px" : isTablet ? "80px" : "120px"}
              height={isMobile ? "48px" : isTablet ? "64px" : "80px"}
              style={{ borderRadius: "12px", flex: "1 1 0", maxWidth: "120px" }}
            />
          ))}
        </div>
      </TitleContainer>
    </>
  );
};
